function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var lineSymbols = ["anticline-hinge", "left-lateral-fault", "normal-fault", "reverse-fault", "right-lateral-fault", "syncline-hinge", "thrust-fault"]; // Bad sources
// id: 225

function symbolLayerPaintProperties(lyr) {
  var _spacing$lyr;

  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _opts$color = opts.color,
      color = _opts$color === void 0 ? "#000000" : _opts$color,
      _opts$reverse = opts.reverse,
      reverse = _opts$reverse === void 0 ? false : _opts$reverse,
      rotate = opts.rotate,
      _opts$sizeExpression = opts.sizeExpression,
      sz = _opts$sizeExpression === void 0 ? function (s) {
    return s;
  } : _opts$sizeExpression;
  var offset = [0, 0];

  if (lyr == "thrust-fault") {
    offset = ["interpolate", ["exponential", 2], ["zoom"], 0, ["literal", [0, 0]], 24, ["literal", [0, 0]]];
  }

  var spacing = {
    "anticline-hinge": 200,
    "syncline-hinge": 200,
    "thrust-fault": ["interpolate", ["exponential", 2], ["zoom"], 0, // stop
    3, // size
    15, 150, 24, 300]
  };
  return {
    type: "symbol",
    layout: {
      "icon-image": lyr,
      "icon-pitch-alignment": "map",
      "icon-allow-overlap": true,
      "symbol-avoid-edges": false,
      "symbol-placement": "line",
      "symbol-spacing": (_spacing$lyr = spacing[lyr]) !== null && _spacing$lyr !== void 0 ? _spacing$lyr : 30,
      "icon-offset": offset,
      "icon-rotate": rotate !== null && rotate !== void 0 ? rotate : reverse ? 180 : 0,
      "icon-size": ["interpolate", ["exponential", 2], ["zoom"], 0, // stop
      sz(0.3), 3, sz(0.5), 15, sz(1.2), // size
      18, sz(4), 24, sz(30)]
    },
    paint: {
      "icon-color": color
    }
  };
}

function createLineSymbolLayers() {
  var symbolLayers = [];

  var _iterator = _createForOfIteratorHelper(lineSymbols),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var lyr = _step.value;
      var color = ["get", "color"];

      if (lyr == "thrust-fault") {
        color = "#000000";
      }

      var val = _objectSpread({
        id: "".concat(lyr, "-stroke"),
        source: "geology",
        "source-layer": "contact",
        filter: ["==", ["get", "type"], lyr]
      }, symbolLayerPaintProperties(lyr, color));

      symbolLayers.push(val);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return symbolLayers;
}

export { lineSymbols, createLineSymbolLayers, symbolLayerPaintProperties };